import useRuntimeConfig from "@/composables/useRuntimeConfig";
import {
  DayExperienceResponse,
  DayExperienceTaxonomyResponse,
} from "@/models/api/DayExperienceResponse";
import { DayExperience } from "@/models/DayExperience";
import { DayExperienceTaxonomy } from "@/models/DayExperienceTaxonomy";
import axios from "axios";

const dayExperienceService = {
  getExperiences(
    islands?: string[],
    categories?: string[],
    text?: string
  ): Promise<DayExperience[]> {
    const { getRuntimeConfig } = useRuntimeConfig();
    return getRuntimeConfig().then((x) => {
      return axios
        .post<DayExperienceResponse[]>(
          `${x.cmsBaseUrl}experience/experiences`,
          {
            islands: islands,
            categories: categories,
            text: text,
          }
        )
        .then((resp) => {
          return resp.data.map((d) => new DayExperience(d));
        });
    });
  },

  getTaxonomies(): Promise<DayExperienceTaxonomy> {
    const { getRuntimeConfig } = useRuntimeConfig();
    return getRuntimeConfig().then((x) => {
      return axios
        .get<DayExperienceTaxonomyResponse>(
          `${x.cmsBaseUrl}experience/taxonomy`
        )
        .then((resp) => new DayExperienceTaxonomy(resp.data));
    });
  },
};

export default dayExperienceService;
